/**
 * Created by vtbelo on 10.04.18.
 */

const LeaguesWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.LEADERS_WINDOW_OPEN);

        this.currentLeague = cleverapps.leagues.league;

        this.leaguesLeaders = {};

        this.content = this.createContent();

        this._super.call(this, {
            name: "LeaguesWindow",
            content: this.content,
            closeButton: !this.tableCloseButton,
            notCloseByTouchInShadow: true,
            noBackground: true,
            styles: cleverapps.styles.LeaguesWindow[cleverapps.resolution.isHorizontal() && "horizontalWindow" || "verticalWindow"]
        });

        this.loadData();
        this.updateArrows();
    },

    createArrows: function () {
        const arrowLeftSlot = this.backgroundSpine.getSlot("slot_arrow_left");
        const arrowRightSlot = this.backgroundSpine.getSlot("slot_arrow_right");

        const arrowLeft = this.arrowLeft = new cleverapps.UI.Button({
            type: {
                button_png: bundles.ui.frames.league_arrow_png,
                button_on_png: bundles.ui.frames.league_arrow_on_png
            },
            onClicked: this.decLeague.bind(this)
        });
        arrowLeft.baseScaleX = -1;
        arrowLeft.baseScaley = 1;
        arrowLeft.setScaleX(-1);
        arrowLeftSlot.addChild(arrowLeft);

        const arrowRight = this.arrowRight = new cleverapps.UI.Button({
            type: {
                button_png: bundles.ui.frames.league_arrow_png,
                button_on_png: bundles.ui.frames.league_arrow_on_png
            },
            onClicked: this.incLeague.bind(this)
        });
        arrowRightSlot.addChild(arrowRight);
    },

    createContent: function () {
        const background = this.createBackground();

        this.createTable();
        this.createArrows();

        return background;
    },

    createBackground: function () {
        const jsons = bundles.leaders_window.jsons;

        const json = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL && jsons.leader_board_vertical
            ? jsons.leader_board_vertical : jsons.leader_board;

        const background = this.backgroundSpine = new cleverapps.Spine(json);
        if (background.hasAnimation("open")) {
            background.setAnimationAndIdleAfter("open", "idle");
        } else {
            background.setAnimation(0, "idle", true);
        }

        if (connector.info.isMobile && cleverapps.resolution.isHorizontal()) {
            background.setScale(1.1);
        }

        const closeSlot = background.hasSlot("slot_close") && background.getSlot("slot_close");
        const titleSlot = this.titleSlot = background.getSlot("slot_title");

        if (closeSlot) {
            const closeButton = this.tableCloseButton = new CloseRoundButton({
                onClicked: this.close.bind(this),
                styles: cleverapps.styles.LeaguesWindow.closeButton
            });
            closeSlot.addChild(closeButton);
        }

        const mainTitle = this.mainTitle = cleverapps.UI.generateOnlyText(Messages.get(`League${cleverapps.leagues.league}`), cleverapps.styles.FONTS.LEADERS_MAIN_TITLE_TEXT);
        mainTitle.setAlignment(titleSlot.width / 2, titleSlot.height / 2);
        titleSlot.addChild(mainTitle);

        this.updateTitle();

        return background;
    },

    loadData: function () {
        cleverapps.loading.show();
        this.loading = true;

        const onLoad = cleverapps.accumulate(300, this.createListener((response) => {
            cleverapps.loading.hide();
            this.loading = false;

            this.leaguesLeaders = {};
            for (let i = 0; i < response.length; i++) {
                const leagueId = i;
                
                this.leaguesLeaders[leagueId] = response[i];
                this.leaguesLeaders[leagueId].forEach((leader) => {
                    leader.league = leagueId;
                });
            }

            for (let j = 0; j < this.getAmountLeagues(); j++) {
                if (!this.leaguesLeaders[j]) {
                    this.leaguesLeaders[j] = [];
                }
            }

            this.updateArrows();
            this.updateTable();
        }));

        if (!cleverapps.flags.nomulti || cleverapps.config.importMode) {
            const leagueIds = Leagues.LEVELS_BORDERS.map((league, index) => `${cleverapps.config.name}_${index}`).join(",");

            connector.multi.leagues.get(leagueIds, (leagues) => {
                if (leagues) {
                    onLoad(leagues);
                } else {
                    cleverapps.notification.create(Messages.get("LeadersLoadFailed"));
                }
            });
        }
    },

    decLeague: function () {
        if (this.currentLeague > 0) {
            this.currentLeague--;
            this.updateArrows();
            this.updateTable();
            this.updateTitle();
        }
    },

    incLeague: function () {
        if (this.currentLeague < this.getAmountLeagues() - 1) {
            this.currentLeague++;
            this.updateArrows();
            this.updateTable();
            this.updateTitle();
        }
    },

    getAmountLeagues: function () {
        return Leagues.LEVELS_BORDERS.length;
    },

    updateArrows: function () {
        if (this.arrowLeft) {
            this.arrowLeft.setVisible(!this.loading && this.currentLeague > 0);
        }

        if (this.arrowRight) {
            this.arrowRight.setVisible(!this.loading && this.currentLeague < this.getAmountLeagues() - 1);
        }
    },

    updateTitle: function () {
        this.mainTitle.setFont(cleverapps.styles.FONTS.LEADERS_MAIN_TITLE_TEXT);
        this.mainTitle.setString(Messages.get(`League${this.currentLeague}`));
        this.mainTitle.fitTo(this.titleSlot.width, this.titleSlot.height);
    },

    getTop: function () {
        const top = this.leaguesLeaders[this.currentLeague] || [];
        this.removePlayerFromTop(top);
        if (cleverapps.leagues.league === this.currentLeague) {
            this.addPlayerToTop(top);
        }

        while (top.length > LeaguesWindow.TOP_LIMIT && top[top.length - 1].id !== connector.platform.getUserID()) {
            top.pop();
        }

        return top;
    },

    updateTable: function () {
        const currentLeague = this.currentLeague;

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.01),
            new cc.CallFunc(() => {
                if (currentLeague !== this.currentLeague) {
                    return;
                }

                this.tableView.removeFromParent();
                this.createTable();
            })
        ));
    },

    removePlayerFromTop: function (top) {
        for (let i = 0; i < top.length; i++) {
            if (top[i].id === connector.platform.getUserID()) {
                top.splice(i, 1);
                break;
            }
        }
    },

    addPlayerToTop: function (top) {
        top.push({
            id: connector.platform.getUserID(),
            rating: levels.user.getVirtualLevel(),
            name: cleverapps.user.getPlayerInfo().name,
            avatar: cleverapps.user.getPlayerInfo().avatar,
            you: true,
            league: cleverapps.leagues.league
        });

        top.sort((a, b) => {
            if (a.rating === b.rating) {
                if (a.id === connector.platform.getUserID()) {
                    return -1;
                }
                if (b.id === connector.platform.getUserID()) {
                    return 1;
                }
                return 0;
            }
            return b.rating - a.rating;
        });
    },

    createTable: function () {
        const dataSource = StaticDataSource(() => {
            const rows = [];
            const top = this.getTop();
            for (let i = 0; i < top.length; i++) {
                const isPlayer = top[i].id === connector.platform.getUserID();
                rows.push({
                    id: top[i].id,
                    score: top[i].rating,
                    pinned: isPlayer,
                    data: {
                        name: top[i].name,
                        place: (i + 1),
                        avatar: {
                            id: top[i].id,
                            avatar: top[i].avatar
                        },
                        player: isPlayer
                    }
                });
            }
            return rows;
        });

        const background = this.backgroundSpine;

        if (background.hasSlot("slot_board_bg")) {
            const boardBgSlot = background.getSlot("slot_board_bg");
            boardBgSlot.setLocalZOrder(-1);
            const boardBg = new cc.Scale9Sprite(bundles.leaders_window.frames.mission_board_bg_png);
            boardBg.setContentSize2(boardBgSlot.getContentSize());
            boardBgSlot.addChild(boardBg);
            boardBg.setAlignment(boardBgSlot.width / 2, boardBgSlot.height / 2);
        }

        const tableSlot = this.backgroundSpine.getSlot("slot_table");

        const table = new ScrollTable(dataSource, { parentView: this });
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            scrollBarEnabled: !table.scrollDisabled,
            mouseScroll: !table.scrollDisabled,
            dock: true
        });

        new TableHandler(table, tableView, {
            id: "LeaguesWindow",
            height: tableSlot.height,
            rowOptions: {
                width: tableSlot.width,
                prizes: false
            }
        });

        tableView.setPosition(tableSlot.width / 2, tableSlot.height / 2);
        tableSlot.addChild(tableView);
    },

    listBundles: function () {
        return ["leaders_window"];
    }
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    LEADERS_STROKE: {
        color: new cc.Color(95, 29, 17, 128),
        size: 1
    },

    LEADERS_SHADOW: {
        color: new cc.Color(11, 13, 37, 128),
        direction: cc.size(0, -3),
        blur: 4
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LEADERS_MAIN_TITLE_TEXT: {
        size: 78,
        color: new cc.Color(255, 201, 39, 255),
        stroke: cleverapps.styles.DECORATORS.LEADERS_STROKE,
        shadow: cleverapps.styles.DECORATORS.LEADERS_SHADOW
    },
    LEADERS_TIMER_TEXT: {
        size: 50,
        color: new cc.Color(255, 220, 132, 255),
        stroke: cleverapps.styles.DECORATORS.LEADERS_STROKE,
        shadow: cleverapps.styles.DECORATORS.LEADERS_SHADOW
    }
});

cleverapps.styles.LeaguesWindow = {
    closeButton: {
        scale: [0.7, 1, 1],
        x: { align: "center" },
        y: { align: "center" }
    },

    verticalWindow: {
        windowShowUpAnimation: undefined,

        Background: {
            padding: {
                x: -10
            }
        }
    },

    horizontalWindow: {
        windowShowUpAnimation: undefined
    }
};

LeaguesWindow.TOP_LIMIT = 100;
